import { Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useSetAtom } from "jotai";
import { paymentTypeAtom } from "../../store/globalstore";

import crossBlack from "../../assets/images/onboardingImages/crossBlack.svg";
import BubbleSvgButton from "../sharedPages/CommonComponents/BubbleSvgButton/BubbleSvgButton";
import CheckIcon from "../../assets/images/greenCheck.svg";
import "./verifyTradeInfo.css";
import { useDispatch, useSelector } from "react-redux";
import { resetOnBoardingStartContext } from "../../redux/users/usersSlice";
const VerifyTradeInfoModal = () => {
  const navigate = useNavigate();
  const setPaymentType = useSetAtom(paymentTypeAtom);
  const { user } = useSelector((state) => state.user);
  const onBoardingStartContext = useSelector(
    (state) => state.user?.onBoardingStartContext
  );
  const dispatch = useDispatch();
  const isConnected =
    user?.binanceCredentials?.isConnected ||
    user?.bybitCredentials?.isConnected;

  const handleClose = () => {
    if (onBoardingStartContext) {
      navigate(onBoardingStartContext, { replace: true });
      dispatch(resetOnBoardingStartContext());
      return;
    }
    navigate("/leader/dashboard", { replace: true });
  };

  return (
    <div className="onboarding-modal-wrapper">
      <Modal
        animation={false}
        backdropClassName="onboarding-custom-backdrop"
        centered
        dialogClassName="custom-onboarding-modal verifyTrdeInfo"
        show={true}
      >
        <Modal.Body className="figma-drop-shadow">
          <button className="CrossIcon" onClick={handleClose} type="button">
            <img alt="crossBlack" src={crossBlack} />
          </button>

          <div className="verifyTradeContent">
            <h2 className="title">Verify Your Trades</h2>
            <p className="desc">
              Verify individual trades or overall performance.
             </p>

            <ul className="infoList">
              <li>
                <span className="checkmark">
                  <img src={CheckIcon} alt="CheckIcon" />
                </span>
                Verify already active trades or trades closed after sign up.
              </li>
              <li>
                <span className="checkmark">
                  <img src={CheckIcon} alt="CheckIcon" />
                </span>
                For accuracy, verify at least 3 months.
              </li>
              <li>
                <span className="checkmark">
                  <img src={CheckIcon} alt="CheckIcon" />
                </span>
                Performance is saved on-chain and shareable via link.
              </li>
            </ul>
          </div>
          <div
            className="d-flex justify-content-center align-items-center flex-column gap-3"
          >
            <BubbleSvgButton
              className="NextBtn"
              onClick={() => {
                setPaymentType("onetime");
                navigate("/leader/verifymyTrade/connection", { replace: true });
              }}
              text={"Verify Individual Trade(s)"}
              type="button"
              variant="black"
              containerStyling={{
                justifyContent: "center",
              }}
              mainDivStyle={{
                width: "275px",
                height: "55px",
              }}
            />

            <BubbleSvgButton
              className="Verify Performance"
              onClick={() => {
                setPaymentType("subscription");
                navigate("/leader/verifymyTrade/connection", { replace: true });
              }}
              text={"Verify My Performance"}
              type="button"
              variant="black"
              containerStyling={{
                justifyContent: "center",
              }}
              mainDivStyle={{
                width: "275px",
                height: "55px",
              }}
            />
          </div>
          <div className="paginationDots">
            <button className="dot active"></button>
            <button className="dot"></button>
            <button className="dot"></button>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default VerifyTradeInfoModal;
